<section class="spacer-pt-space spacer-pb-space bg-black">
    <div class="container">
        <div class="row gap-y-10 md:flex-row-reverse">
            <div class="col-md-6 xl:pl-20">
                <h2 class="heading-primary-8xl mb-6 text-white xl:mb-[46px]">What's Next?</h2>
                <ul class="contentList">
                    @for (item of listdata; track $index) {
                    <li>
                        {{item.listtext}}
                    </li>
                    }
                </ul>
                <a type="button" routerLink="contact-us" (click)="handler_redirect(2)" title="Let's talk"
                    class="button button-orange button-rounded button-arrow mt-4 md:mt-8">Let's talk
                </a>
            </div>
            <div class="col-md-6">
                <div class="p-6 bg-white rounded-[6px] xl:p-[42px] xl:rounded-[10px]">
                    <h2 class="heading-primary-8xl !mb-6 xl:!mb-[46px]">
                        Request a <u class="after:!z-[1]"><span class="relative z-[2]">Call
                                Back</span></u></h2>
                    <form [formGroup]="contactUsForm" (ngSubmit)="onSubmit()">
                        <div class="form-group mb-5 xl:mb-9">
                            <label for="">Name<sup>*</sup></label>
                            <input type="text" class="form-control capitalize" restrictCopyPaste formControlName="name"
                                maxlength="50" data-type="input" input-mask="letterOnly">
                            @if (contactUsForm.get('name')?.touched && contactUsForm.get('name')?.errors){
                            @if (contactUsForm.get('name')?.hasError('required')){
                            <span class="error">Please Enter your name</span>
                            }
                            @if (contactUsForm.get('name')?.hasError('minlength') ||
                            contactUsForm.get('name')?.hasError('pattern')){
                            <span class="error">Please enter a valid name</span>
                            }
                            }

                        </div>
                        <div class="form-group mb-5 xl:mb-9">
                            <label for="">Email<sup>*</sup></label>
                            <input type="email" class="form-control" input-mask="email" restrictCopyPaste maxlength="50"
                                formControlName="email" data-type="input">

                            @if (contactUsForm.get('email')?.touched && contactUsForm.get('email')?.errors){
                            @if (contactUsForm.get('email')?.hasError('required')){
                            <span class="error">Please enter your email</span>
                            }
                            @if (contactUsForm.get('email')?.hasError('pattern')){
                            <span class="error">Please enter a valid email</span>
                            }
                            }
                        </div>
                        <div class="form-group mb-5 xl:mb-10">
                            <label for="">Phone Number<sup>*</sup></label>
                            <input type="text" class="form-control" restrictCopyPaste maxlength="10"
                                formControlName="phone_number" input-mask="numberOnlyStartWithFive" data-type="input">
                            @if (contactUsForm.get('phone_number')?.touched &&
                            contactUsForm.get('phone_number')?.errors){
                            @if (contactUsForm.get('phone_number')?.hasError('required')){
                            <span class="error">Please enter phone number</span>
                            }
                            @if (contactUsForm.get('phone_number')?.hasError('minlength')){
                            <span class="error">Please enter a valid phone number</span>
                            }
                            }
                        </div>
                        <div class="form-group mb-5 xl:mb-9 type-select hide">
                            <label for="Selectbox">Interest</label>
                            <input type="text" class="form-control" restrictCopyPaste formControlName="objective"
                                id="Selectbox" (click)="handler__selectInput($event)" readonly autocomplete="off">
                            <div class="select-box" (click)="handler__selectBox($event)">
                                <ng-scrollbar thumbClass="custom-scrollbars">
                                    <ul>
                                        <li (click)="handler__selectOption($event,'objective')">
                                            Wealth Management
                                            Services</li>
                                        <li (click)="handler__selectOption($event,'objective')">
                                            Lending Solutions
                                        </li>
                                        <li (click)="handler__selectOption($event,'objective')">
                                            Protection Solutions
                                        </li>
                                        <li (click)="handler__selectOption($event,'objective')">
                                            Global Investment
                                            Opportunities</li>
                                        <li (click)="handler__selectOption($event,'objective')">
                                            Inheritance and
                                            Legacy Planning</li>
                                    </ul>
                                </ng-scrollbar>
                            </div>
                            @if (contactUsForm.get('objective')?.touched &&
                            contactUsForm.get('objective')?.errors){
                            @if
                            (contactUsForm.get('objective')?.hasError('required')){
                            <span class="error">Please Enter Interest</span>
                            }
                            @if
                            (contactUsForm.get('objective')?.hasError('objective')){
                            <span class="error">Please enter a valid Interest</span>
                            }
                            }
                        </div>
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="form-group mb-5 xl:mb-9">
                                    <label for="">Enter Captcha<sup>*</sup></label>
                                    <input type="text" class="form-control" restrictCopyPaste input-mask="numberAndText"
                                        formControlName="captcha_form" maxlength="6" data-type="input">
                                    @if (contactUsForm.get('captcha_form')?.touched &&
                                    contactUsForm.get('captcha_form')?.errors){
                                    @if (contactUsForm.get('captcha_form')?.hasError('required')){
                                    <span class="error">Please enter captcha</span>
                                    }
                                    @if (contactUsForm.get('captcha_form')?.hasError('minlength')){
                                    <span class="error">Please enter a valid captcha</span>
                                    }
                                    }
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-group mb-5 xl:mb-9">
                                    <div class="flex items-center gap-2">
                                        <img [src]="queryCaptcha" alt="captcha" width="198" height="50" loading="lazy"
                                            fetchpriority="auto">
                                        <img [ngSrc]="assetsCDNUrl+'/assets/images/icons/refresh-black.svg'"
                                            alt="Refresh captcha" (click)="generateCaptcha()"
                                            class="min-w-7 min-h-7 w-7 h-7 cursor-pointer" title="Refresh captcha"
                                            width="50" height="50" loading="lazy" fetchpriority="auto">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <app-toast *ngIf="showToastFailure" [showToastFailure]="showToastFailure" [toastMsg]="message">
                        </app-toast>

                        <button type="submit" [disabled]="!contactUsForm.valid || showToastFailure || showToastSuccess"
                            title="Get in Touch" class="button button-black button-arrow button-rounded">Get in
                            Touch</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>
<app-congratulation-popup [showToastSuccess]="showToastSuccess" [toastMsg]="message">
</app-congratulation-popup>